export interface Project {
  id: number;
  name: string;
  description: string;
  status: 'active' | 'draft' | 'completed';
  teams: number;
  membersPerTeam: number;
  deadline: string;
  deliverables: number;
  created: string;
}

export interface TeamMember {
  name: string;
}

export interface SubmittedFile {
  name: string;
  type: string;
}

export interface Submission {
  id: string;
  projectName: string;
  status: 'submitted' | 'graded' | 'pending';
  teamMembers: TeamMember[];
  files: SubmittedFile[];
  submittedDate: string;
}

export const getProjects = async (): Promise<{
  success: boolean;
  data?: Project[];
  error?: { message: string } | null;
}> => {
  try {
    // ===== USING MOCK DATA =====
    const response: Project[] = [
      {
        id: 1,
        name: 'Customer Service Excellence Initiative',
        description: 'Develop a comprehensive customer service improvement plan for a',
        status: 'active',
        teams: 8,
        membersPerTeam: 4,
        deadline: '12/15/2025',
        deliverables: 3,
        created: '2 weeks ago',
      },
      {
        id: 2,
        name: 'Mobile App Design Sprint',
        description: 'Design and prototype a mobile application solving a real-world',
        status: 'active',
        teams: 6,
        membersPerTeam: 5,
        deadline: '12/20/2025',
        deliverables: 3,
        created: '1 week ago',
      },
      {
        id: 3,
        name: 'Data Analytics Case Study',
        description: 'Analyze sales data and provide actionable business insights',
        status: 'active',
        teams: 10,
        membersPerTeam: 3,
        deadline: '12/10/2025',
        deliverables: 3,
        created: '3 weeks ago',
      },
    ];

    await new Promise(resolve => setTimeout(resolve, 500));
    return {
      success: true,
      data: response,
      error: null
    };

    // ===== API IMPLEMENTATION (Currently commented out) =====
    // const response = await httpClient.get<Project[]>(ENDPOINTS.PROJECTS);
    // return { success: true, data: response, error: null };

  } catch (error: any) {
    return {
      success: false,
      error: { message: error?.message ?? 'Failed to fetch projects' }
    };
  }
};

export const getSubmissions = async (): Promise<{
  success: boolean;
  data?: Submission[];
  error?: { message: string } | null;
}> => {
  try {
    // ===== USING MOCK DATA =====
    const response: Submission[] = [
      {
        id: '1',
        projectName: 'Design Squad',
        status: 'submitted',
        teamMembers: [
          { name: 'Lisa Chen' },
          { name: 'Mark Roberts' },
          { name: 'Nina Patel' },
          { name: 'Oscar Kim' },
          { name: 'Paula Garcia' }
        ],
        files: [
          { name: 'App_Prototype.fig', type: 'figma' },
          { name: 'Documentation.pdf', type: 'pdf' }
        ],
        submittedDate: '2025-11-27'
      }
    ];

    await new Promise(resolve => setTimeout(resolve, 600));
    return {
      success: true,
      data: response,
      error: null
    };

    // ===== API IMPLEMENTATION (Currently commented out) =====
    // const response = await httpClient.get<Submission[]>(ENDPOINTS.SUBMISSIONS);
    // return { success: true, data: response, error: null };

  } catch (error: any) {
    return {
      success: false,
      error: { message: error?.message ?? 'Failed to fetch submissions' }
    };
  }
};
